<template>
  <div>
    <v-card
      style="width:100%;"
      class="d-flex justify-center"
      v-if="!showMobileView"
    >
      <v-layout
        class="d-flex justify-center align-center pr-4"
        style="height:80px; width: 100%;"
      >
        <div class="d-flex align-center pl-5" style="width:100%; height:80px;">
          <h4
            style="color:gray; padding-right:4px;"
            @click="goBack()"
            class="go-back"
          >
            One Way > {{ data.uuid }}
          </h4>
        </div>
      </v-layout>
    </v-card>
    <div class="d-flex flex-wrap justify-center ma-0">
      <one-way-info-card />
      <div :class="divClass" style="width:100%;">
        <div :style="notesStyle" :class="noteClass">
          <reconciliation-notes />
        </div>
        <div :class="noteClass" :style="mapStyle">
          <one-way-locations />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ReconciliationDetailData from '@/mixins/ReconciliationDetailData';
import { MobileView } from '@/mixins';
import ReconciliationNotes from '@/components/reconciliation/ReconciliationNotes.vue';
import OneWayInfoCard from '@/components/reconciliation/OneWayInfoCard.vue';
import OneWayLocations from '@/components/reconciliation/OneWayLocations.vue';
import router from '../router';

export default {
  mixins: [ReconciliationDetailData, MobileView],
  components: {
    ReconciliationNotes,
    OneWayLocations,
    OneWayInfoCard,
  },
  computed: {
    ...mapGetters({
      currentClient: 'account/getCurrentClient',
      _clientIsSet: 'account/getClientIsSet',
    }),
    mapStyle() {
      if (this.showMobileView) {
        return 'overflow:hidden; width:100%;';
      }
      return 'height:fit-content; width:65%';
    },
    notesStyle() {
      if (this.showMobileView) {
        return 'overflow:hidden; width:100%;';
      }
      return 'height:fit-content; width:35%';
    },
    noteClass() {
      if (this.showMobileView) {
        return '';
      }
      return 'ma-4';
    },
    divClass() {
      if (this.showMobileView) {
        return 'd-flex flex-column mx-4';
      }
      return 'd-flex';
    },
  },
  methods: {
    ...mapActions({
      _acquireData: 'reconciliationDetails/acquireDetails',
    }),
    goBack() {
      router.push(
        `/${this.currentClient.name
          .toLowerCase()
          .replace(/\s/g, '')}/reconciliation`,
      );
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    if (this._clientIsSet) {
      this._acquireData(this.$route.params.id);
    }
  },
  watch: {
    _clientIsSet() {
      if (this._clientIsSet) {
        this._acquireData(this.$route.params.id);
      }
    },
  },
};
</script>

<style>
.go-back:hover {
  cursor: pointer;
}
</style>
